import { Button, Typography } from '@mui/material';
import { FC } from 'react';

import { Colors } from '@/assets';

interface IProps {
    title: string;
    onClick?: () => void;
    submit?: boolean;
    size?: 'md' | 'lg' | 'xl';
    white?: boolean;
    icon?: string;
    disabled?: boolean;
    width?: number;
}

const getVariantBySizeButton = (size: string) => {
    switch (size) {
        case 'md':
            return 'subtitle1';
        case 'lg':
            return 'caption';
        case 'xl':
            return 'h6';
        default:
            return 'caption';
    }
};

export const PrimaryButton: FC<IProps> = ({ title, disabled, onClick, submit, size = 'xl', white, icon, width }) => {
    return (
        <Button
            type={submit ? 'submit' : 'button'}
            onClick={onClick}
            disabled={disabled}
            sx={{
                width: width ?? '100%',
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: disabled ? Colors.greenWhite : white ? Colors.white : Colors.slateBlueViolet,
                border: '1px solid',
                borderColor: white ? Colors.linkWater : 'transparent',
                borderRadius: '8px',
                p: 1.5,
                ':hover': {
                    background: `${white ? Colors.white : Colors.slateBlueViolet}90`
                },
                textTransform: 'none',
                whiteSpace: 'nowrap',
                minWidth: 'unset'
            }}
        >
            {icon && (
                <Typography className={icon} sx={{ fontSize: 18, color: white ? Colors.cloudBurstBlue : Colors.white, mr: 1 }}></Typography>
            )}
            <Typography
                variant={getVariantBySizeButton(size)}
                sx={{ fontWeight: 500, color: white ? Colors.cloudBurstBlue : Colors.white }}
            >
                {title}
            </Typography>
        </Button>
    );
};
